module.exports = __webpack_public_path__ + "static/media/card-bg-2.47bdd4c0.png";